

export const ROLES = Object.freeze({
    ROLE_SYSTEM_ADMIN: "ROLE_SYSTEM_ADMIN",
    ROLE_MANAGER: "ROLE_MANAGER",
    ROLE_ADVERTISER: "ROLE_ADVERTISER",
    ROLE_PUBLISHER: "ROLE_PUBLISHER",
    ROLE_REPORTER: "ROLE_REPORTER"
})